import ShipmentBridges from 'components/modules/shipments/ShipmentBridges';
import CargomaticModal from 'components/v2/modal';
import { t } from 'i18next';
import React, { forwardRef } from 'react';
export const ShipmentLegEditor = forwardRef(({ stopEditing, node }, ref) => {
    const { shipment_oid, shipment_id } = (node === null || node === void 0 ? void 0 : node.data) || {};
    const handleHide = () => {
        stopEditing();
    };
    const getFooter = () => {
        return (React.createElement("div", { className: "flex items-center justify-end" },
            React.createElement("button", { className: "button button-secondary", type: "button", onClick: handleHide }, t('CLOSE'))));
    };
    return (React.createElement(CargomaticModal, { title: `${t('SHIPMENT_BRIDGE_AND_EVENT_CODES')} - ${shipment_id}`, titleClassNames: "font-semibold leading-none tracking-tight", dialogClassName: "w-[80vw] h-[80vh]", contentClassName: "h-full", showCloseButton: false, show: true, onHide: handleHide, body: React.createElement(ShipmentBridges, { shipmentId: shipment_oid, showHeader: false, isPaginated: false }), footer: getFooter() }));
});
